export class digitalListDB {
    static digital_list = [
        {
            id: "21",
            img: "<img src='assets/images/digital-product/web-dev.jpg' class='imgTable'>",
            title: "Websites",
            entry_type: "Add",
            quantity: "5",
        },
        {
            id: "172",
            img: "<img src='assets/images/digital-product/3d-design.jpg' class='imgTable'>",
            title: "3D Impact",
            entry_type: "Destroy",
            quantity: "11",
        },
        {
            id: "124",
            img: "<img src='assets/images/digital-product/graphic-design.png' class='imgTable'>",
            title: "Graphic Design",
            entry_type: "Destroy",
            quantity: "154",
        },
        {
            id: "37",
            img: "<img src='assets/images/digital-product/logo.jpg' class='imgTable'>",
            title: "Company Logo",
            entry_type: "Destroy",
            quantity: "1",
        },
        {
            id: "67",
            img: "<img src='assets/images/digital-product/application.jpg' class='imgTable'>",
            title: "Application",
            entry_type: "Add",
            quantity: "24",
        },
        {
            id: "74",
            img: "<img src='assets/images/digital-product/php.png' class='imgTable'>",
            title: "Php",
            entry_type: "Destroy",
            quantity: "1",
        },
        {
            id: "427",
            img: "<img src='assets/images/digital-product/html.png' class='imgTable'>",
            title: "Html",
            entry_type: "Destroy",
            quantity: "27",
        },
        {
            id: "142",
            img: "<img src='assets/images/digital-product/css.jpg' class='imgTable'>",
            title: "Css",
            entry_type: "Add",
            quantity: "2",
        },
        {
            id: "58",
            img: "<img src='assets/images/digital-product/ebooks.png' class='imgTable'>",
            title: "Ebooks",
            entry_type: "Add",
            quantity: "4",
        }
    ]
}
